import { useQuery } from "react-query";
import axiosClient from "./../config/axiosClient";
import { downloadFile } from "../utils/file";

const useInvestorsList = ({page, per_page, company_id}) => {
  return useQuery(
    ["investors", company_id, page],
    () => {
      return axiosClient
        .get(`/issuer/companies/${company_id}/investors.json`, {params: {page, per_page}})
    }, {
      initialData: [],
    }
  );  
}

const useExportInvestorsList = ({company_id, opts={enabled: false}}) => {
  return useQuery(
    ['investors', company_id, 'export'],
    () => {
      return axiosClient
        .get(`/issuer/companies/${company_id}/investors.csv`)
    },
    {
      ...opts,
      onSuccess: (data) => {
        downloadFile(data, `investors-${company_id}.csv`)
      }
    }
  );
}

export {
  useInvestorsList,
  useExportInvestorsList,
}
